export const COMMERCIAL_TERMS_URL = "https://das.dev/legal/terms";

export function commercialGoverningTermsParts(text: string) {
  return text.split(/(https:\/\/das\.dev\/legal\/terms)(?=$|\s|[.,;:!?)](?=\s|$))/gu);
}
